const MAX_JSON_TABLES = 50;
const MAX_JSON_TABLE_ROWS = 1000;

const isPlainObject = (value) => (
  value !== null &&
  typeof value === 'object' &&
  !Array.isArray(value)
);

const formatJsonCell = (value) => {
  if (value === null || value === undefined) return '';
  if (typeof value === 'boolean') return value ? 'true' : 'false';
  if (typeof value === 'number' || typeof value === 'string') return value;
  try {
    return JSON.stringify(value);
  } catch (_) {
    return String(value);
  }
};

const tableNameFromPath = (path) => path || 'root';

const arrayToTable = (name, rows) => {
  const previewRows = rows.slice(0, MAX_JSON_TABLE_ROWS);
  const columns = [];
  const seenColumns = new Set();

  previewRows.forEach((row) => {
    Object.keys(row || {}).forEach((key) => {
      if (!seenColumns.has(key)) {
        seenColumns.add(key);
        columns.push(key);
      }
    });
  });

  return {
    name,
    sourceRowCount: rows.length,
    truncated: rows.length > previewRows.length,
    data: [
      columns,
      ...previewRows.map((row) => columns.map((column) => formatJsonCell(row?.[column]))),
    ],
  };
};

const collectTables = (value, path, tables) => {
  if (tables.length >= MAX_JSON_TABLES) return;

  if (Array.isArray(value)) {
    if (value.length > 0 && value.every(isPlainObject)) {
      tables.push(arrayToTable(tableNameFromPath(path), value));
    }
    value.slice(0, 5).forEach((item, index) => {
      if (isPlainObject(item) || Array.isArray(item)) {
        collectTables(item, path ? `${path}.${index}` : String(index), tables);
      }
    });
    return;
  }

  if (!isPlainObject(value)) return;

  Object.entries(value).forEach(([key, child]) => {
    if (tables.length >= MAX_JSON_TABLES) return;
    const childPath = path ? `${path}.${key}` : key;
    if (Array.isArray(child)) {
      if (child.length > 0 && child.every(isPlainObject)) {
        tables.push(arrayToTable(childPath, child));
      }
      child.slice(0, 5).forEach((item, index) => {
        if (isPlainObject(item) || Array.isArray(item)) {
          collectTables(item, `${childPath}.${index}`, tables);
        }
      });
    } else if (isPlainObject(child)) {
      collectTables(child, childPath, tables);
    }
  });
};

export const parseJsonViewerContent = (text) => {
  const parsed = JSON.parse(text);
  const tables = [];
  collectTables(parsed, Array.isArray(parsed) ? 'root' : '', tables);

  return {
    formatted: JSON.stringify(parsed, null, 2),
    tables,
  };
};
